import { faCopy, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext } from "react";
import { Alert, Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { BasicContext } from "../App";

const SummaryViewAfterPayment = (props) => {
    const { t } = useTranslation();
    const { pass, summaryView, paymentMethod, discountCode, signUpForClass, onClose, onProceed } = props;
    const { setAlerts } = useContext(BasicContext);

    const priceWithDiscount = (price) => {
        return discountCode.discount_value
            ? price - discountCode.discount_value < 0
                ? 0
                : price - discountCode.discount_value
            : discountCode.discount_rate
            ? (discountCode.discount_rate * price) / 100
            : price;
    };

    return (
        <>
            <Modal.Body>
                <p className="h5">{t("payments.purchaseDetails")}</p>
                <p className="mb-1">
                    {t("passes.passName")}: <strong>{pass.pass_name}</strong>
                </p>
                <p className="mb-1">
                    {t("payments.purchaseDate")}: <strong>{summaryView.up_purchase_date}</strong>
                </p>
                <p className="mb-1">
                    {t("payments.paymentMethod")}:{" "}
                    <strong>{paymentMethod === "CASH" ? t("payments.cash") : paymentMethod === "MONEY_TRANSFER" ? t("payments.moneyTransfer") : ""}</strong>
                </p>
                <p className="mb-3">
                    {t("payments.orderNumber")}: <strong>{summaryView.orderNumber}</strong>
                </p>
                {paymentMethod === "MONEY_TRANSFER" && (
                    <>
                        <p className="h5">{t("payments.dataForMoneyTransfer")}</p>
                        <p className="mb-1">
                            {t("payments.receiver")}: <strong>{summaryView.accountName}</strong>
                            <Button
                                variant="outline-secondary"
                                size="sm"
                                className="d-inline-block ms-2"
                                onClick={() => {
                                    navigator.clipboard.writeText(summaryView.accountName);
                                    setAlerts([{ variant: "info", message: t("info.copiedToClipboard"), fading: 1000, id: "copyClipboardreceiver" }]);
                                }}
                            >
                                <FontAwesomeIcon icon={faCopy} />
                            </Button>
                        </p>
                        <p className="mb-1">
                            {t("payments.accountNumber")}: <strong className="text-small">{summaryView.accountNumber.replace(/(\d{4})(?=\d)/g, "$1 ")}</strong>
                            <Button
                                variant="outline-secondary"
                                size="sm"
                                className="d-inline-block ms-2"
                                onClick={() => {
                                    navigator.clipboard.writeText(summaryView.accountNumber);
                                    setAlerts([{ variant: "info", message: t("info.copiedToClipboard"), fading: 1000, id: "copyClipboardaccountNumber" }]);
                                }}
                            >
                                <FontAwesomeIcon icon={faCopy} />
                            </Button>
                        </p>
                        <p className="mb-1">
                            {t("payments.moneyTransferTitle")}:{" "}
                            <strong>
                                {pass.pass_name} ({summaryView.orderNumber})
                            </strong>
                            <Button
                                variant="outline-secondary"
                                size="sm"
                                className="d-inline-block ms-2"
                                onClick={() => {
                                    navigator.clipboard.writeText(`${pass.pass_name} (${summaryView.orderNumber})`);
                                    setAlerts([{ variant: "info", message: t("info.copiedToClipboard"), fading: 1000, id: "copyClipboardorderNumber" }]);
                                }}
                            >
                                <FontAwesomeIcon icon={faCopy} />
                            </Button>
                        </p>
                        <p className="mb-3">
                            {t("payments.moneyTransferAmount")}:{" "}
                            <strong>
                                {priceWithDiscount(pass.pass_price)} {t("currency")}
                                <Button
                                    variant="outline-secondary"
                                    size="sm"
                                    className="d-inline-block ms-2"
                                    onClick={() => {
                                        navigator.clipboard.writeText(`${priceWithDiscount(pass.pass_price)}`);
                                        setAlerts([{ variant: "info", message: t("info.copiedToClipboard"), fading: 1000, id: "copyClipboardPrice" }]);
                                    }}
                                >
                                    <FontAwesomeIcon icon={faCopy} />
                                </Button>
                            </strong>
                        </p>
                    </>
                )}
                <Alert variant="info" className="mb-3">
                    <FontAwesomeIcon icon={faInfoCircle} className="me-2 text-info" />
                    {t("info.passPurchased")}
                </Alert>
            </Modal.Body>
            {signUpForClass ? (
                <Modal.Footer>
                    <Button variant="outline-secondary" onClick={onProceed}>
                        {t("close")}
                    </Button>
                </Modal.Footer>
            ) : (
                <Modal.Footer>
                    <Button variant="outline-secondary" onClick={onClose}>
                        {t("close")}
                    </Button>

                    <Button variant="primary" onClick={onProceed}>
                        {t("schedule.displaySchedule")}
                    </Button>
                </Modal.Footer>
            )}
        </>
    );
};

export default SummaryViewAfterPayment;
